import dayjs from "dayjs"

export const checkIfSameDate = (firstDate, secondDate) => {
  return firstDate.isSame(dayjs(secondDate), "day")
}
